(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-discovery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('submit', (event) => {
  const form = event.target.closest('[data-snt-search]');
  if (!form) return;

  const scope = form.querySelector('[data-snt-scope]');
  const query = form.querySelector('[data-snt-query]');
  if (!scope || !query) return;

  const term = query.value.trim();
  if (!term || !scope.value) return;

  const escaped = term.replace(/"/g, '\\"');
  query.value = scope.value + ':"' + escaped + '"';
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["storefront-discovery"] && !Shopify.designMode) return;
  try {
    
function sntSubcategoriesFor(form, departmentHandle) {
  const section = form.closest('.snt-storefront-discovery');
  const groups = section?.querySelectorAll('[data-snt-category-group]') || [];
  const group = Array.from(groups).find(node => node.dataset.sntCategoryGroup === departmentHandle);
  if (!group) return [];

  return Array.from(group.querySelectorAll('[data-snt-subcategory-handle]'))
    .map(node => [node.dataset.sntSubcategoryHandle, node.dataset.sntSubcategoryLabel])
    .filter(([handle]) => Boolean(handle));
}

document.addEventListener('change', (event) => {
  const department = event.target.closest('[data-snt-department]');
  if (!department) return;

  const form = department.closest('[data-snt-global-search]');
  const subcategory = form?.querySelector('[data-snt-subcategory]');
  if (!subcategory) return;

  subcategory.replaceChildren();

  if (!department.value) {
    subcategory.add(new Option('Select a department first', ''));
    subcategory.disabled = true;
    return;
  }

  const departmentName = department.options[department.selectedIndex].text;
  subcategory.add(new Option('Shop all ' + departmentName, department.value));

  for (const [handle, label] of sntSubcategoriesFor(form, department.value)) {
    subcategory.add(new Option(label, handle));
  }

  subcategory.disabled = false;
});

document.addEventListener('submit', (event) => {
  const form = event.target.closest('[data-snt-global-search]');
  if (!form) return;

  const department = form.querySelector('[data-snt-department]');
  const subcategory = form.querySelector('[data-snt-subcategory]');
  const query = form.querySelector('[data-snt-global-query]');
  const price = form.querySelector('[data-snt-price]');
  const inStock = form.querySelector('[data-snt-in-stock]');
  const term = query?.value.trim() || '';
  const collectionHandle = subcategory?.value || department?.value || '';

  event.preventDefault();

  const params = new URLSearchParams();
  const isBudgetCollection = collectionHandle === 'under-5';
  const parts = (price?.value || '').split(':');
  let minimum = parts[0] || '';
  let maximum = parts[1] || '';
  if (price?.value === '0:5' || isBudgetCollection) {
    maximum = maximum ? String(Math.min(Number(maximum), 4.99)) : '4.99';
  }
  if (minimum) params.set('filter.v.price.gte', minimum);
  if (maximum) params.set('filter.v.price.lte', maximum);
  if (inStock?.checked) params.set('filter.v.availability', '1');
  const sort = form.querySelector('[data-snt-sort]')?.value || '';
  if (sort) params.set('sort_by', sort);

  let destination;
  if (!term && collectionHandle) {
    destination = collectionHandle === 'all' ? '/collections/all' : '/collections/' + encodeURIComponent(collectionHandle);
  } else {
    destination = form.getAttribute('action') || '/search';
    params.set('type', 'product');
    params.set('q', term || '*');
  }
  window.location.assign(destination + '?' + params.toString());
});

const sntDepartmentMedia = window.matchMedia('(max-width: 749px)');

function syncSntDepartmentCards() {
  document.querySelectorAll('.snt-storefront-discovery__department').forEach((department) => {
    department.open = !sntDepartmentMedia.matches;
  });
}

document.addEventListener('click', (event) => {
  const summary = event.target.closest('.snt-storefront-discovery__department-title');
  if (!summary) return;

  if (!sntDepartmentMedia.matches) {
    event.preventDefault();
  }
});

document.addEventListener('toggle', (event) => {
  const opened = event.target;
  if (!sntDepartmentMedia.matches || !opened.matches('.snt-storefront-discovery__department') || !opened.open) return;

  opened.closest('.snt-storefront-discovery__department-grid')
    ?.querySelectorAll('.snt-storefront-discovery__department[open]')
    .forEach((department) => {
      if (department !== opened) department.open = false;
    });
}, true);

syncSntDepartmentCards();
sntDepartmentMedia.addEventListener?.('change', syncSntDepartmentCards);


  } catch(e) { console.error(e); }
})();
})();
